// Module
var code = "<template>\n  <require from=\"./pen-offer-scope-container\"></require>\n  <pen-offer-scope-container pen-offer-scope-id.bind=\"data.penOfferScopeId\"></pen-offer-scope-container>\n</template>\n";
// Exports
export default code;